import { Typography } from '@mui/material'
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import {
  postAddAssociations,
  postAddBatch,
} from '../../services/productService'
import { CSVLink } from 'react-csv'
import LoadingScreen from '../../utils/LoadingScreen'

const Associations = () => {
  const [jsonData, setJsonData] = useState(null)
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleConvert = (file) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const data = e.target.result
      const workbook = XLSX.read(data, { type: 'binary' })
      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]
      const json = XLSX.utils.sheet_to_json(worksheet)
      setJsonData(JSON.stringify(json, null, 2))
    }
    reader.readAsBinaryString(file)
  }

  // const handleConvert = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     const data = e.target.result;
  //     const workbook = XLSX.read(data, { type: "binary" });
  //     const sheetName = workbook.SheetNames[0];
  //     const worksheet = workbook.Sheets[sheetName];

  //     let json = XLSX.utils.sheet_to_json(worksheet);

  //     const sanitizeValue = (value) => {
  //       if (typeof value === "string") {
  //         let sanitizedValue = value.replace(/\t/g, " ").replace(/\r/g, "");
  //         sanitizedValue = sanitizedValue.replace(/^[=+\-@]/g, "");
  //         return sanitizedValue;
  //       }
  //       return value;
  //     };

  //     json = json.map((row) => {
  //       return Object.fromEntries(
  //         Object.entries(row).map(([key, value]) => [key, sanitizeValue(value)])
  //       );
  //     });

  //     setJsonData(JSON.stringify(json, null, 2));
  //   };
  //   reader.readAsBinaryString(file);
  // };

  const add = async () => {
    if (jsonData === null) {
      toast.error('Please upload a file')
    } else {
      try {
        // console.log(jsonData);
        setLoading(true)
        const response = await postAddAssociations(JSON.parse(jsonData))
        // console.log("response", response);
        setLoading(false)
        if (response['status'] === 'success') {
          toast.success('Party master added successfully')
        } else {
          toast.error(response.error.response.statusText)
        }
      } catch (error) {
        setLoading(false)
        toast.error(error.message)
      }
    }
  }

  // const handleBatchMasterFileChange = async (event) => {
  //   const selectedFile = event.target.files[0];
  //   setFile(selectedFile);
  //   console.log("file :", selectedFile);

  //   // Optionally sanitize the file content here
  //   if (selectedFile && selectedFile.name.endsWith(".csv")) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const result = e.target.result;
  //       const sanitizedCSV = sanitizeCSV(result);
  //       const blob = new Blob([sanitizedCSV], { type: "text/csv" });
  //       const sanitizedFile = new File([blob], selectedFile.name, {
  //         type: selectedFile.type,
  //       });
  //       setFile(sanitizedFile);
  //     };
  //     reader.readAsText(selectedFile);
  //   }
  // };

  // const sanitizeCSV = (csvContent) => {
  //   const rows = csvContent.split("\n").map((row) => {
  //     const cells = row.split(",").map((cell) => {
  //       if (typeof cell === "string" && cell.match(/^[=+\-@]/)) {
  //         return `'${cell}`;
  //       }
  //       return cell;
  //     });
  //     return cells.join(",");
  //   });
  //   return rows.join("\n");
  // };

  // const addBatch = async () => {
  //   // console.log("File===>", file);
  //   if (file === null) {
  //     toast.error("Please upload a file");
  //   } else {
  //     try {
  //       const formData = new FormData();
  //       formData.append("products", file);
  //       setLoading(true);
  //       // console.log("FormData===>", formData);

  //       const response = await postAddBatch(formData);
  //       // console.log("response", response);
  //       setLoading(false);

  //       if (response["status"] === "success") {
  //         toast.success("Batch master added successfully");
  //       } else {
  //         toast.error(response.error.response.statusText);
  //       }
  //     } catch (error) {
  //       setLoading(false);
  //       toast.error(error.message);
  //     }
  //   }
  // };

  const handleBatchMasterFileChange = (event) => {
    setFile(event.target.files[0])
    // console.log("file :", event.target.files[0]);
  }

  const addBatch = async () => {
    // console.log("File===>", file);
    if (file === null) {
      toast.error('Please upload a file')
    } else {
      try {
        const formData = new FormData()
        formData.append('products', file)
        setLoading(true)
        // console.log("FormData===>", formData);
        const response = await postAddBatch(formData)
        // console.log("response", response);
        setLoading(false)

        if (response['status'] === 'success') {
          toast.success('Batch master added successfully')
        } else {
          toast.error(response.error.response.statusText)
        }
      } catch (error) {
        setLoading(false)
        toast.error(error.message)
      }
    }
  }

  // console.log("jsonData", jsonData);

  if (loading) {
    return (
      <LoadingScreen loading={loading} message={'Uploading, please wait..'} />
    )
  }
  return (
    <>
      <div style={{ display: 'flex', width: '100%', gap: 25 }}>
        <div style={{ width: '50%' }}>
          <Typography
            variant="h5"
            style={{ textAlign: 'center', marginBottom: 20 }}
          >
            Party Master
          </Typography>

          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <input
                  onChange={(e) => {
                    handleConvert(e.target.files[0])
                  }}
                  accept=".csv"
                  type="file"
                  className="form-control"
                  placeholder="file 1"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <button onClick={add} className="btn btn-success">
                Upload
              </button>

              <CSVLink
                headers={['code', 'name', 'address', 'GST', 'region']}
                data={[
                  {
                    code: '239484092',
                    name: 'TEST1',
                    address: 'TEST1',
                    GST: 'TEST1',
                    region: 'north',
                  },
                  {
                    code: '9349349349',
                    name: 'TEST2',
                    address: 'TEST2',
                    GST: 'TEST2',
                    region: 'north',
                  },
                ]}
                filename="Sample_Party_Master.csv"
                style={{ textDecoration: 'none', color: '#fff' }}
              >
                <span
                  style={{
                    textDecoration: 'underline',
                    color: 'blue',
                    alignSelf: 'center',
                    marginLeft: 20,
                    cursor: 'pointer',
                  }}
                >
                  Sample CSV Download
                </span>
              </CSVLink>
            </div>
            {/* <div className="col">
              <p
                style={{
                  textDecoration: 'underline',
                  color: 'blue',
                  alignSelf: 'center',
                }}
                onClick={add}
                className="float-end"
              >
                Sample CSV Download
              </p>
            </div> */}
          </div>
        </div>
        <div style={{ width: '50%' }}>
          <Typography
            variant="h5"
            style={{ textAlign: 'center', marginBottom: 20 }}
          >
            Batch Master
          </Typography>

          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <input
                  onChange={handleBatchMasterFileChange}
                  accept=".csv,.xls,.xlsx"
                  type="file"
                  className="form-control"
                  placeholder="file 1"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <button onClick={addBatch} className="btn btn-success">
                Upload
              </button>
              <CSVLink
                headers={[
                  'ITEM_CODE',
                  'SKU',
                  'BATCHNUMBER',
                  'MRP',
                  'EXPIRYDATE',
                  'MFG_DATE',
                  'BARCODE1',
                  'BARCODE2',
                  'OPTIONAL1',
                  'OPTIONAL2',
                  'OBATCH',
                ]}
                data={[
                  {
                    ITEM_CODE: 'TEST12123',
                    SKU: 'Test1',
                    BATCHNUMBER: 'E21115',
                    OBATCH: 'E-21115',
                    MRP: 1,
                    EXPIRYDATE: '05-2023',
                    MFG_DATE: '06-2021',
                  },
                  {
                    ITEM_CODE: 'TEST1123',
                    SKU: 'Test2',
                    BATCHNUMBER: 'E1115',
                    OBATCH: 'E-1115',

                    MRP: 12.1,
                    EXPIRYDATE: '05-2023',
                    MFG_DATE: '06-2021',
                  },
                ]}
                filename="Sample_Batch_Master.csv"
                style={{ textDecoration: 'none', color: '#fff' }}
              >
                <span
                  style={{
                    textDecoration: 'underline',
                    color: 'blue',
                    alignSelf: 'center',
                    marginLeft: 20,
                    cursor: 'pointer',
                  }}
                >
                  Sample CSV Download
                </span>
              </CSVLink>
            </div>
          </div>
        </div>
      </div>
      <hr />
      {/* <div style={{ width: '50%', margin: '0 auto 0 auto' }}>
        <Typography
          variant="h5"
          style={{ textAlign: 'center', marginBottom: 20 }}
        >
          Edit Batch
        </Typography>

        <div className="row">
          <div className="col">
            <div className="input-group mb-3"> */}
      {/* <input
                onChange={handleBatchMasterFileChange}
                accept=".csv"
                type="file"
                className="form-control"
                placeholder="file 1"
              /> */}
      {/* <input type="text" className="form-control" />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col"></div>
        </div>
      </div> */}
    </>
  )
}

export default Associations
